import styles from '../auth.module.css'
import { MailOutlined } from "@ant-design/icons";
import { Spin, Alert, Form, Input, Button, Space } from "antd";
import { firebaseEmailSignin, firebaseEmailVerify } from "../../../lib/auth/actions";
import { KaceyView } from "../../../types";
import { signOut } from "../../../lib/auth/actions";
import { useEffect } from 'react';
import { win } from '../../../lib/utils';

export const VerifyEmailForm: KaceyView<{ actionPath?: string, cancelText?: string, className?: string }> = (params) => {
    const { actionPath } = params || {};

    const [_, progress] = firebaseEmailVerify();

    const onFinish = ({ email }: { email: string }) => {
        progress.value.exec({ email, actionPath });
        // fb.requestEmailAuthCode(form);
    };

    const [__, signInProgress] = firebaseEmailSignin();

    useEffect(() => {
        const urlParams = new URLSearchParams(win?.location?.search || "");
        const oobCode = urlParams.get("oobCode");
        if (oobCode)
            signInProgress.value.exec();
    }, [signInProgress]);


    if (progress.value.inProgress)
        return <Spin />;

    if (progress.value.executions > 0 && progress.value.paused)
        return <>Please check your email (also the spam folder, just in case). Click the link in the email to verify your email address.</>


    return <div className={params.className}>
        {
            signInProgress.value.error && !(progress.value.executions > 0) ?
                <>
                    <Alert message={signInProgress.value.error?.message || ""}></Alert>
                    <br />
                </>
                :
                <></>
        }
        {progress.value.error && <Alert type='error' message={progress.value.error?.message} />}
        <Form
            name="normal_login"
            className="login-form"
            initialValues={{
                remember: true,
            }}
            onFinish={onFinish}
        >
            <Form.Item
                name="email"
                rules={[
                    {
                        required: true,
                        message: 'Please input your email',
                    },
                ]}
            >
                <Input prefix={<MailOutlined className="site-form-item-icon" />} placeholder="Email" />
            </Form.Item>
            <Form.Item>
                <Space className="footer">
                    <div>
                        {params?.cancelText || "Already have a username?"}<br />
                        <a onClick={(e) => {
                            // e.preventDefault();
                            signOut({ route: "/auth" });
                        }}>Sign in</a>
                    </div>
                    <Button id="sign-in-button" type="primary" htmlType="submit" className="login-form-button">
                        Verify
                    </Button>
                </Space>
            </Form.Item>
        </Form>


        {/* <a href="/auth">Sign in</a>&nbsp;&nbsp; */}
    </div>
}
